// extracted by mini-css-extract-plugin
export default {"whyContainer":"Why_whyContainer__cS-bK","icon":"Why_icon__fg9wS","title":"Why_title__1f7FU","description":"Why_description__Qk9fe"};